namespace RioERP.Web.Enums {
    export enum SharingType {
        Percentage = 1,
        FixAmount = 2
    }
    Serenity.Decorators.registerEnumType(SharingType, 'RioERP.Web.Enums.SharingType');
}
